import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {useSelector} from "react-redux";
import classnames from "classnames";
import WebPaths from "@router/paths/web";
import isUrlValid from "@utils/isUrlValid";
import {Col, Nav, NavItem, Row} from "reactstrap";
import "./megaMenuTwo.scss";
import "./megaMenu.scss";
import "./normalMenu.scss";
import {RxHamburgerMenu} from "react-icons/rx";
import imageMenu from "@assets/images/elements/menuImage.webp"

/**
 * Menu type (mega-menu, normal-menu, mega-menu-2)
 **/
const TypeOfMenu = "normal-menu";

const Menu = () => {
    const [menu, setMenu] = useState(
        localStorage.getItem('menu') ? JSON.parse(localStorage.getItem('menu')) : []
    );
    const menuUpdate = useSelector(state => state.UI.general?.menu);
    const navigate = useNavigate();
    const location = useLocation();

    const [activeOut, setActiveOut] = useState(null);
    const [activeIn, setActiveIn] = useState(null);
    const [grandChild, setGrandChild] = useState([]);
    const [grandGrandChild, setGrandGrandChild] = useState([]);

    useEffect(() => {
        if (menuUpdate) setMenu(menuUpdate);
    }, [menuUpdate]);

    const MenuType = {
        DoorCategory: 0,
        PieceCategory: 1,
        InternalLink: 2,
        ExternalLink: 3,
        serviceCategory: 4,

    };

    const MenuOpen = {
        InTab: 0,
        NewTab: 1
    };

    const MenuStatus = {
        Active: 0,
        UnClickable: 1,
        Invisible: 2
    };

    const TypeOfMenuCondition = {
        megaMenu: "mega-menu",
        normalMenu: "normal-menu",
        megaMenu2: "mega-menu-two"
    };

    const hasChild = id => menu.some(f => f.parentId === id);

    const handleUrl = (item) => {
        const {openIn, url, type, category} = item;

        const navigateToUrl = (url) => {
            if (isUrlValid(url)) {
                window.location = url;
            } else {
                navigate(url);
            }
        };

        switch (parseInt(type)) {
            case MenuType.DoorCategory:
                navigateToUrl(WebPaths.products());
                break;
            case MenuType.PieceCategory:
                navigateToUrl(WebPaths.category(category.slug));
                break;
            case MenuType.InternalLink:
            case MenuType.ExternalLink:
                openIn === MenuOpen.NewTab ? window.open(url, "_blank") : navigateToUrl(url);
                break;
            case MenuType.serviceCategory:
                navigateToUrl(WebPaths.services(category.slug));
                break;
            default:
                break;
        }
    };

    const handleCheckIsActive = (menuItem) => {
        const {url, category} = menuItem;
        if (url) {
            if (isUrlValid(url)) return window.location.href === url;
            const internalUrl = url.charAt(0) === "/" ? url : `/${url}`;
            return location.pathname + location.search === internalUrl;
        }
        return location.pathname === "/products" && location.search.includes(encodeURI(category.slug));
    };

    const tabToggle = (tab, data) => {
        const childData = menu.filter(p => p.parentId === data.id);
        setGrandChild(childData);
        setGrandGrandChild([]); // Clear grand-grand children
        setActiveIn(null);
    };

    const toggleOut = (tabId) => {
        setActiveOut((prevActiveOut) => {
            const newActiveOut = prevActiveOut !== tabId ? tabId : null;
            if (newActiveOut === null) {
                setGrandChild([]);
                setGrandGrandChild([]); // Clear grand-grand children
            } else {
                const childData = menu.filter(p => p.parentId === newActiveOut);
                if (childData.length > 0) tabToggle(0, childData[0]);
                else setGrandChild([]);
            }
            return newActiveOut;
        });
        setActiveIn(null);
    };

    const handleGrandChildMouseEnter = (id) => {
        setActiveIn(id);
        const grandGrandChildren = menu.filter(item => item.parentId === id);
        setGrandGrandChild(grandGrandChildren);
    };

    const renderChildren = (
        <Nav tabs className="mb-0 flex-column justify-content-around">
            {menu.filter(item => item.parentId === activeOut).map((child, index) => (
                <NavItem key={index} className="cursor-pointer">
                    <div
                        onMouseEnter={() => tabToggle(index, child)}
                        onClick={() => handleUrl(child)}
                        className={classnames({
                            'menu-item': true,
                            'menu-tab-disabled': child.status === MenuStatus.UnClickable
                        })}
                    >
                        <span>{child.title}</span>
                    </div>
                </NavItem>
            ))}
        </Nav>
    );

    const renderGrandChildren = grandChild.map((grandChildItem, index) => (
        <div className="mb-1" key={grandChildItem.id}>
            <div
                onClick={() => handleUrl(grandChildItem)}
                className="grandChild cursor-pointer"
                onMouseEnter={() => handleGrandChildMouseEnter(grandChildItem.id)}
            >
                {grandChildItem.title}
            </div>
            <ul>
                {menu.filter(p => p.parentId === grandChildItem.id).map((grandGrandChild, index) => (
                    <li key={index} className="" onClick={() => handleUrl(grandGrandChild)}>
                        <a href={grandGrandChild.link} className="grandchildren">
                            {grandGrandChild.title}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    ));

    const renderSubMenu = (parent_id = "main", limit = 1) => {
        let itemsToRender = menu
            .filter(item => item.parentId === parent_id)
            .sort((a, b) => a.index - b.index);

        // If limit is 1, render only the first 6 items
        /*   if (limit === 1) {
               itemsToRender = itemsToRender.slice(0, 6);
           }*/

        return itemsToRender.map(menuItem => {
            if (menuItem.status === MenuStatus.Invisible) return null;
            const menuItemButton = (
                <button
                    className={classnames("menu-item", {
                        'has-child': hasChild(menuItem.id),
                        'lock': menuItem.status === MenuStatus.UnClickable,
                        'active': handleCheckIsActive(menuItem)
                    })}
                    disabled={menuItem.status === MenuStatus.UnClickable}
                    onMouseEnter={() => hasChild(menuItem.id) ? toggleOut(menuItem.id) : setActiveOut(null)}
                    onClick={() => menuItem.status !== MenuStatus.UnClickable && handleUrl(menuItem)}
                >
                <span className={classnames("title", {'Open': menuItem.collapse})}>
                   {/*{hasChild(menuItem.id) && limit === 1 && <RxHamburgerMenu className="" style={{marginLeft:"5px"}} />}*/}
                    {menuItem.title}
                </span>
                </button>
            );

            let view;
            switch (TypeOfMenu) {
                case TypeOfMenuCondition.megaMenu:
                    view = (
                        <>
                            {menuItemButton}
                            {menuItem.canHaveChild && hasChild(menuItem.id) && (
                                <div className={classnames({"sub-menu": limit < 2})}>
                                    <Row>
                                        <Col sm={limit < 2 ? 12 : 12}
                                             className={`${limit < 2 ? "sub-menu-right" : "sub-menu-right-child"}`}>
                                            {renderSubMenu(menuItem.id, limit + 1)}
                                        </Col>
                                        {/*      {limit < 2 && <Col sm={4} className="d-flex align-items-center justify-content-center">
                                            <img src={imageMenu} width={'100%'} height={"100%"} />
                                        </Col> }*/}
                                    </Row>
                                </div>
                            )}
                        </>
                    );
                    break;
                case TypeOfMenuCondition.normalMenu:
                    view = (
                        <>
                            {menuItemButton}
                            {menuItem.canHaveChild && hasChild(menuItem.id) && (
                                <div className="sub-menu">
                                    {renderSubMenu(menuItem.id, limit + 1)}
                                </div>
                            )}
                        </>
                    );
                    break;
                case TypeOfMenuCondition.megaMenu2:
                    view = (
                        <>
                            {menuItemButton}
                            {activeOut && (
                                <>
                                    <div className="mega-menu-shadow"></div>
                                    <div className="wrapper rounded" onMouseLeave={() => toggleOut('')}>
                                        <div className="d-flex">
                                            <div className="menu-content In">
                                                {renderChildren}
                                            </div>
                                            <div className="p-1 menu-child-content ">
                                                {renderGrandChildren}
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </>
                    );
                    break;
                default:
                    view = null;
                    break;
            }

            return (
                <div className={classnames("box-item", {
                    'has-child-top': limit === 1 && hasChild(menuItem.id)
                })} key={menuItem.id}>
                    {view}
                </div>
            );
        });
    };


    if (!menu?.length) return null;
    return (
        <div className={TypeOfMenu}>
            {renderSubMenu()}
        </div>
    );
};

export default Menu;
